import { onLoad } from '@otto-ec/global-resources/dom';

/**
 *
 *
 *
 *
 *
 */
export function afterPageLoad(callback: () => void): () => void {
    let timeout: ReturnType<typeof setTimeout> | undefined;
    const run = () => {
        if (timeout !== undefined) return;
        timeout = setTimeout(callback, 0);
    };
    const unsubscribe = onLoad.on(run, { once: true });
    if (document.readyState === 'complete') run();

    return () => {
        unsubscribe();
        clearTimeout(timeout);
    };
}
